import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import AOS from 'aos';
import 'aos/dist/aos.css';
import SEO from '../components/SEO/SEO';
import './Services.css';
import './Services/Services.css';

const products = [
  {
    id: 'answerrank',
    icon: 'fas fa-brain',
    name: 'FirmaSearch',
    description:
      'AI-powered platform that tracks your brand visibility inside AI responses and closes the gap between you and your competitors.',
    link: '/products/firmasearch',
    external: false,
  },
  {
    id: 'hiresmart',
    icon: 'fas fa-user-tie',
    name: 'HireSmart',
    description:
      'Intelligent talent acquisition platform that matches the right tech talent to the right roles — faster and with less friction.',
    link: 'https://hiresmart.sradhatech.com',
    external: true,
  },
  {
    id: 'datanexis',
    icon: 'fas fa-project-diagram',
    name: 'Orchix Ai',
    description:
      'Registry-driven, zero-code data pipeline platform built on Microsoft Fabric, PySpark, and Delta Lake. Automate end-to-end pipelines from ingestion to analytics-ready data.',
    link: '/products/orchix-ai',
    external: false,
  },
];

const Products = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <>
      <SEO
        title="Products & Solutions"
        description="Sradha Technologies products: FirmaSearch (AEO platform), HireSmart (AI tech hiring), and Orchix Ai (zero-code data pipelines on Microsoft Fabric)."
        keywords="AI products, AEO, answer engine optimization, brand visibility, FirmaSearch, HireSmart, talent acquisition, Orchix AI, data pipeline, Microsoft Fabric"
        canonical="https://sradhatech.com/products"
        jsonLd={{
          '@context': 'https://schema.org',
          '@type': 'ItemList',
          name: 'Sradha Technologies Products',
          description: 'AI-powered software products and enterprise platforms built by Sradha Technologies',
          url: 'https://sradhatech.com/products',
          itemListElement: [
            {
              '@type': 'ListItem',
              position: 1,
              item: {
                '@type': 'SoftwareApplication',
                name: 'FirmaSearch',
                description: 'AI Answer Engine Optimization (AEO) platform for tracking and improving brand visibility in ChatGPT, Claude, and Gemini responses',
                url: 'https://sradhatech.com/products/firmasearch',
              },
            },
            {
              '@type': 'ListItem',
              position: 2,
              item: {
                '@type': 'SoftwareApplication',
                name: 'HireSmart',
                description: 'AI-powered talent acquisition platform for tech hiring with smart candidate matching, automated shortlisting, and hiring analytics',
                url: 'https://hiresmart.sradhatech.com',
              },
            },
            {
              '@type': 'ListItem',
              position: 3,
              item: {
                '@type': 'SoftwareApplication',
                name: 'Orchix Ai',
                description: 'Zero-code enterprise data pipeline platform on Microsoft Fabric, PySpark, and Delta Lake with registry-driven automation',
                url: 'https://sradhatech.com/products/orchix-ai',
              },
            },
          ],
        }}
      />
      <div className="services-page">
        <div className="service-header">
          <h1>Products &amp; Solutions</h1>
          <p>Purpose-built tools that solve real problems</p>
        </div>

        <div className="container">
          <div className="services-grid">
            {products.map((p, i) => (
              <div
                key={p.id}
                className="service-card"
                data-aos="fade-up"
                data-aos-delay={i * 100}
              >
                <div className="service-icon">
                  <i className={p.icon}></i>
                </div>
                <h3>{p.name}</h3>
                <p>{p.description}</p>
                {p.external ? (
                  <a
                    href={p.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="learn-more"
                  >
                    Learn More
                  </a>
                ) : (
                  <Link to={p.link} className="learn-more">
                    Learn More
                  </Link>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default Products;
